export enum LoadingStage {
    NOT_INITIALIZED = "notInitialized",
    IS_INITIALIZING = "isInitializing",
    INITIALIZE_COMPLETE = "initializeComplete",
    INITIALIZE_FAILURE = "initializeFailure",
    IS_LOADING = "isLoading",
    LOADING_COMPLETE = "loadingSuccess",
    LOADING_FAILURE = "loadingFailure",
}

export const InitStages = [
    LoadingStage.NOT_INITIALIZED,
    LoadingStage.IS_INITIALIZING,
    LoadingStage.INITIALIZE_COMPLETE,
    LoadingStage.INITIALIZE_FAILURE,
];

export const LoadingStages = [
    LoadingStage.IS_LOADING,
    LoadingStage.LOADING_COMPLETE,
    LoadingStage.LOADING_FAILURE,
];
